
import Component from 'vue-class-component';
import Vue from 'vue';
import {FormError, ValidationInstruction} from '@/types/FormErrors';

@Component({
  name: 'FormErrorsMixin',
})

export default class FormErrorsMixin extends Vue {

  public formErrors: Array<FormError> = [];

  public getFormErrors<Form extends Record<string, string|number|File|undefined>>(
    instructions: Array<ValidationInstruction>,
    form: Form,
  ): void {
    this.formErrors = instructions.reduce<Array<FormError>>((formErrors, {field, rules}) => {
      const message: string|boolean|undefined =  rules
        .map(rule => rule(form[field]))
        .find(result => result !== true);

      return ('string' === typeof message) ? [...formErrors, {field, message}] : formErrors;
    }, []);
  }

  public state(field: string): boolean|null {
    const fieldInvalid = this.formErrors.some((error) => error.field === field);
    return  fieldInvalid ? false : null;
  }

  public invalidFeedback(field: string): string|null {
    const formError = this.formErrors.find((error) => error.field === field);
    return formError ? formError.message : null;
  }

  public clearErrors(field: string): void {
    if (!this.formErrors.length) {
      return;
    }
    this.formErrors = this.formErrors.filter(error => error.field !== field);
  }
}
